import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { motion } from 'framer-motion'
import { pageVariant } from '../animation'
import MobileHeader from './MobileHeader'

const Eta = ({ children }) => {
    return (
        <div className='main'>
            <Header />
            <MobileHeader />

            <motion.div {...pageVariant}>
                {children}
            </motion.div>
            
            <Footer />
        </div>
    )
}

export default Eta
